import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 1.412c-.644 0-1.176.27-1.68.653-.477.364-1.007.894-1.642 1.53l-.307.307-.225.225-.01.01L.803 7.47a.75.75 0 0 0 0 1.06c.293.293.924.03 1.06 0 .137-.03.72-.313.72-.313v2.533c0 1.886 0 2.828.586 3.414.586.586 1.529.586 3.414.586h2.834c1.885 0 2.828 0 3.414-.586.586-.586.586-1.528.586-3.414V8.217s.583.283.72.313c.136.03.767.293 1.06 0a.75.75 0 0 0 0-1.06l-3.333-3.334-.013-.012a89.946 89.946 0 0 0-.221-.222l-.308-.307c-.635-.636-1.165-1.166-1.642-1.53-.504-.384-1.036-.653-1.68-.653Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgHome = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgHome;
